import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import './JobApplications.css';

const JobApplications = () => {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        // Query ordered by date descending (latest first)
        const q = query(
          collection(db, 'applications'),
          orderBy('date', 'desc')
        );

        const querySnapshot = await getDocs(q);

        const apps = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setApplications(apps);
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };

    fetchApplications();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';

    return timestamp.toDate().toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="job-applications">
      <h1>Job Applications</h1>

      <div className="applications-list">
        {applications.map(app => (
          <Link
            key={app.id}
            to={`/applicant/${app.id}`}
            className="application-card"
          >
            <div className="applicant-info">
              <h3>{app.name}</h3>
              <p>{app.job}</p>

              {/* Application Date */}
              <p style={{ fontSize: '0.85em', color: '#999', marginTop: '6px' }}>
                Applied on {formatDate(app.date)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default JobApplications;
